interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "AFN";
};

const AFN: Currency = Object.freeze({
  "displayName": "Afghan Afghani",
  "numericCode": 971,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "AFN",
  "symbol": "؋"
});

export { AFN };
